angular.module("PlatformStatisticsApp").factory("PlatformInviteStatisticsFactory", ["$resource", function ($resource) {
    return $resource("/api/v1.0/profiles/platform-stats/", {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}]);